import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrors, ConflictError, NotFoundError } from '@fitness-force/models';;
import type { CrreateOrganizationRequest, ListOrganization, Organization, UpdateOrganizationRequest } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { map, catchError, throwError, Observable } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  private http = inject(HttpClient);
  private router = inject(Router);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  ListOrganization(tenantId: number): Observable<ListOrganization> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.ORGANIZATION.GET_ORGANIZATIONS
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .get<ListOrganization>(
        url,
        { headers: this.httpOptions.headers }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetOrganization(
    tenantId: number,
    organizationId: number
  ): Observable<Organization> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.ORGANIZATION.GET_ORGANIZATION_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{organization_id}', organizationId.toString());
    return this.http
      .get<Organization>(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  CreateOrganization(tenantId: number,createOrganization: CrreateOrganizationRequest) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.ORGANIZATION.CREATE_ORGANIZATION
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .post(
        url,
        createOrganization,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  UpdateOrganization(
    tenantId: number,
    organizationId: number,
    updateRequest: UpdateOrganizationRequest
  ) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.ORGANIZATION.UPDATE_ORGANIZATION
      .replace('{tenant_id}', tenantId.toString())
      .replace('{organization_id}', organizationId.toString());
    return this.http
      .put(
        url,
        updateRequest,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  ActiveOrganization(tenantId: number, organizationId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.ORGANIZATION.MARK_ORGANIZATION_ACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{organization_id}', organizationId.toString());
    return this.http
      .post(
        url,
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
  
  InActiveOrganization(tenantId: number, organizationId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.ORGANIZATION.MARK_ORGANIZATION_INACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{organization_id}', organizationId.toString());
    return this.http
      .post(
        url,
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
